// extracted by mini-css-extract-plugin
export default {"spinner":"FullScreenLoader_spinner__mcQvb","up":"FullScreenLoader_up__frani","down":"FullScreenLoader_down__3ncxL"};